import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
// import alerts from './plugins/alerts';
// import helpers from './plugins/helpers';
import router from "./router";
import ExportToCSV from "./directive/ExportToCSV";
import Storage from "@/utils/storage";
import "./main.css";
import './plugins/alerts';
import './plugins/helpers';
import './plugins/validations';
import './plugins/date';
import "./services";
import axios from 'axios'
import VueCookies from 'vue-cookies'
import { getSelectedOfficeLocation } from './utils/officeLocation';



// Vue.use(alerts);
// Vue.use(helpers);
Vue.confißproductionTip = false;

Vue.directive('exporttocsv', ExportToCSV);
Vue.use(VueCookies);


// let officeLocation = Storage.get("location");
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  if (config.url.includes("https")) {
    return config;
  }
  
  const token = VueCookies.get("auth_token") || VueCookies.get("token");
  
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  Object.assign(config.headers, { 'office-location': Vue.prototype.selectedLocation });

  return config;
}, function (error) {
  console.log(error)
  return Promise.reject(error);
});

axios.interceptors.response.use(undefined, function (error) {
  if (error.response.status === 401) {
    window.location.href = '#/login';
    Storage.clear();
    return Promise.reject(error);
  }
});

Vue.prototype.location = "";
Vue.prototype.selectedLocation = getSelectedOfficeLocation();

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

